//JS for critical path


//SVG Inlining
var fetchSVG = function fetchSVG(url) {
    fetch(url).then(function (data) {
        return data.text();
    }).then(function (data) {
        var svgEles = cacheLoc[url];
        for (var i = 0; i < svgEles.length; ++i) {
            var _url = svgEles[i].getAttribute('data-url').split('#');
            svgEles[i].removeAttribute('data-url');
            addSvgToDOM(data, svgEles[i], _url[1]);
        }
    });
};

function addSvgToDOM(data, el, sID) {
    var parser = new DOMParser();
    var parsed = parser.parseFromString(data, 'image/svg+xml');
    var svg = parsed.getElementsByTagName('svg');
    if (svg.length) {
        svg = svg[0];
        var attr = svg.attributes;
        var attrLen = attr.length;
        for (var i = 0; i < attrLen; ++i) {
            if (attr[i].specified) {
                if ('class' === attr[i].name) {
                    var classes = attr[i].value.replace(/\s+/g, ' ').trim().split(' ');
                    var classesLen = classes.length;

                    for (var j = 0; j < classesLen; ++j) {
                        el.classList.add(classes[j]);
                    }
                } else {
                    el.setAttribute(attr[i].name, attr[i].value);
                }
            }
        }

        if (!sID) {
            el.innerHTML = svg.innerHTML;
            return
        }
        var findID = false;
        svg.childNodes.forEach(function (item) {
            if (item.id == sID) {
                el.innerHTML = item.innerHTML;
                findID = true;
            }
        });
        if (findID) return;
        el.innerHTML = svg.innerHTML;
    }
}

var cacheURL = {};
var cacheLoc = {};

window.addEventListener('DOMContentLoaded', function () {
    var svgs = document.querySelectorAll('svg[data-url]');
    for (var i = 0; i < svgs.length; ++i) {
        var url = svgs[i].getAttribute('data-url').split('#');
        if (!cacheLoc[url[0]]) {
            cacheLoc[url[0]] = [];
        }
        cacheLoc[url[0]].push(svgs[i]);
    }
    var svgURLs = Object.keys(cacheLoc);
    for (var j = 0; j < svgURLs.length; j++) {
        fetchSVG(svgURLs[j]);
    }
});

//Script load utilities and Wistia

function scriptExists(src) {
    return document.querySelector('script[src$="' + src + '"]') !== null;
}

function onloadScript(src, time, callback) {
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.addEventListener('load', function () {
        console.log('Script loads: ' + src)
        if (callback) callback();
    });
    if (document.readyState === "complete") {
        setTimeout(function () {
            document.body.append(script)
        }, time);
    } else {
        window.addEventListener('load', function () {
            setTimeout(function () {
                document.body.append(script)
            }, time);
        });
    }
}





window.addEventListener('DOMContentLoaded', function () {
    var loadWistia = document.querySelector('[src*="wistia"]') !== null || document.querySelector('[class*="wistia_embed"]') !== null;
    //Load Wistia if there is no background image provided
    var emptyWistiaBG = document.querySelector('.replace-wistia-img__bg') !== null && document.querySelector('.replace-wistia-img__bg img') === null;
    loadWistia = loadWistia || emptyWistiaBG;
    if (loadWistia) {
        checkWistia("//fast.wistia.com/assets/external/E-v1.js", 0);
    }
    document.querySelectorAll('.js-wistia-play').forEach(function (ele) {
       ele.addEventListener('click', function() {

           var wistiaLoaded = checkWistia(function() {
               setTimeout(function () {
                   ele.click();
               }, 100);
           });
           if (!wistiaLoaded) { return false; }
           if (window.$ === undefined) { return false; }
           var $this = $(this);
           playWistia($this);
       });
    });
});

function checkWistia(callback) {
    if (!scriptExists("//fast.wistia.com/assets/external/E-v1.js")) {
        if (callback) {
            window.wistiaInitQueue = window.wistiaInitQueue || [];
            window.wistiaInitQueue.push(callback);
        }
        onloadScript("//fast.wistia.com/assets/external/E-v1.js", 0);
        return false;
    }
    return typeof Wistia !== "undefined";
}

function playWistia(selector) {
    if (typeof Wistia === 'undefined') return;
    if (window.$ === undefined) return;

    var video = Wistia.api(selector.siblings('.replace-wistia-img__wistia').find('.wistia_embed').attr('id'));

    if (!video) return;

    if (!video.ready()) {
        setTimeout(function () {
            playWistia(selector);
        }, 50);
        return false;
    }
    var $this = selector;
    if (!$this[0].nextElementSibling.querySelector('span')) {
        $this[0].parentElement.children[0].style.display = 'none';
        $this[0].parentElement.children[1].style.display = 'none';
        $this.siblings('.replace-wistia-img__wistia').addClass('is-show');
    } else if (!$this[0].nextElementSibling.querySelector('span').classList.contains('popover=true')) {
        $this[0].parentElement.children[0].style.display = 'none';
        $this[0].parentElement.children[1].style.display = 'none';
        $this.siblings('.replace-wistia-img__wistia').addClass('is-show');
    }
    video.play();
}

function pauseWistia(selector) {
    if (typeof Wistia === 'undefined') { return; }
    if (window.$ === undefined) { return; }

    var video = Wistia.api(selector.siblings('.replace-wistia-img__wistia').find('.wistia_embed').attr('id'));
    video.pause();
}